/*
    Parametri di base per autoCompleteJS per applicare il tema Bootstrap
*/
export function autocomplete_params()
{
    return {
        resultsList: {
            class: 'list-group mt-2 position-absolute w-100 z-3',
            maxResults: 50,
        },
        resultItem: {
            class: 'list-group-item p-2',
            highlight: 'active',
            selected: 'active',
            element: (item, data) => {
                item.innerHTML = data.value.text;
            },
        },
    }
}
